import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=cead038e&scoped=true&"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=cead038e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cead038e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VRadio,VRadioGroup})
